var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CaretDown',{staticClass:"transform duration-200 transition-all transform stroke-current",class:{ 'rotate-180 text-orange-500': _vm.show }})
}
var staticRenderFns = []

export { render, staticRenderFns }